import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(
    private router: Router,
    public _auth: AuthService
  ) { }

  ngOnInit(): void {
    this.performLogout();
  }

  async performLogout() {
    console.log('🔴 LOGOUT COMPONENT: Iniciando performLogout()');
    try {
      await this._auth.logout();
      console.log('🔴 LOGOUT COMPONENT: logout() completado, redirigiendo...');

      // Usar Angular Router para evitar loops con reloadVersion
      console.log('🔴 LOGOUT COMPONENT: Redirigiendo a:', environment.loginRoute);
      this.router.navigate([environment.loginRoute]);
    } catch (error) {
      console.error('🔴 LOGOUT COMPONENT: Error en logout:', error);
      // Incluso si hay error, redirigir al login
      this.router.navigate([environment.loginRoute]);
    }
  }

}
